// SPDX-License-Identifier: MIT

import React from 'react';

import ConsentManager from './ConsentManager';
import { resolveConsentTypes } from './resolveTrackers';

// Renders the banner from the plugin's gatsby-config options, so the whole
// consent config lives in one place. Declarative `trackers` on each consent type
// are resolved here into real load/unload callbacks (see resolveTrackers.js).
export const wrapRootElement = ({ element }, pluginOptions = {}) => {
  const { consentTypes } = resolveConsentTypes(pluginOptions.consentTypes);
  const config = { ...pluginOptions, consentTypes };

  return (
    <>
      {element}
      <ConsentManager config={config} />
    </>
  );
};

// Fire consent-gated tracker page views on SPA navigation. Options are passed to
// this hook too, so trackers are rebuilt from the same specs (cheap, stateless);
// each handler is a no-op until its consent loaded the tracker. The entry page
// view is fired by onAccept, so skip the initial route (prevLocation is null).
export const onRouteUpdate = ({ prevLocation }, pluginOptions = {}) => {
  if (!prevLocation) return;
  const { onRouteChange } = resolveConsentTypes(pluginOptions.consentTypes);
  onRouteChange();
};
